import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    initialize() {}

    connect() {
	this.handleResize = this.onResize.bind(this)
	window.addEventListener('resize', this.handleResize)

	const safeIdle = window.requestIdleCallback || function (cb) {
	    return setTimeout(() => cb({ timeRemaining: () => 50 }), 1)
	}

	safeIdle(() => this.autoResizeColumns())
    }

    disconnect() {
	window.removeEventListener('resize', this.handleResize)
    }

    onScroll() {
	if ($(this.element).find('.section-list-load-more').length && ($(window).scrollTop() > ($(document).height() - $(window).height() - 1000))) {
	    let loadMoreButton = $(this.element).find('.section-list-load-more a.load-more-btn')
	    Rails.fire(loadMoreButton[0], "click")
	}
    }

    autoResizeColumns() {
	const rows = Array.from(this.element.querySelectorAll('.table .thead .tr, .table .tbody .tr'))
	if (rows.length === 0) return

	const data = rows.map(row =>
	    Array.from(row.querySelectorAll('.th, .td')).map(cell => cell.textContent.trim())
	)

	const numCols = data[0]?.length || 0
	const longestStrings = new Array(numCols).fill('')

	data.forEach(row => {
	    row.forEach((text, colIndex) => {
		if (text.length > longestStrings[colIndex].length) {
		    longestStrings[colIndex] = text
		}
	    })
	})

	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')

	const sampleCell = this.element.querySelector('.table .thead .tr .th, .table .tbody .tr .td')
	if (!sampleCell) return
	ctx.font = window.getComputedStyle(sampleCell).font

	const maxWidths = []

	longestStrings.forEach((text, colIndex) => {
	    const refCell = this.element.querySelector(`.table .thead .tr .th:nth-child(${colIndex + 1}), .table .tbody .tr .td:nth-child(${colIndex + 1})`);
	    if (!refCell) return

	    const styles = window.getComputedStyle(refCell)
	    const truncatedText = text.slice(0, 100)
	    // The W * 1 measurement is to provide extra gutter space in the cell.
	    const textWidth = ctx.measureText(truncatedText).width + (ctx.measureText("W").width) * 1
	    const padding = parseFloat(styles.paddingLeft || 0) + parseFloat(styles.paddingRight || 0)
	    const border = parseFloat(styles.borderLeftWidth || 0) + parseFloat(styles.borderRightWidth || 0)

	    const total = textWidth + padding + border
	    maxWidths[colIndex] = `${Math.ceil(total)}px` // Round up for safety
	})

	// Apply widths as CSS variables to grid container
	maxWidths.forEach((width, i) => {
	    this.element.querySelector('.table .table-wpr').style.setProperty(`--col-${i + 1}-width`, width)
	})

	// Set grid-template-columns	
	const template = maxWidths.map((_, i) => `var(--col-${i + 1}-width)`).join(' ')
	this.element.querySelector('.table .table-wpr').style.gridTemplateColumns = template

	this.setTooltips()
    }

    setTooltips() {
	this.element.querySelectorAll('.table .thead .tr .th, .table .tbody .tr .td').forEach((el) => {
	    if (el.scrollWidth > el.clientWidth) {
		el.setAttribute("title", el.textContent.trim())
	    } else {
		el.removeAttribute("title")
	    }
	})
    }

    onResize() {
	clearTimeout(this.resizeTimeout)
	this.resizeTimeout = setTimeout(() => {
	    this.autoResizeColumns()
	}, 150)
    }
}
